import styled from 'styled-components';

import { media } from '../../core';

const ContainerStyled = styled.div.attrs({
  className: 'container',
})`
  width: 100%;
  max-width: 58.438rem;
  display: block;
  padding: 1rem;
  margin: 0 auto;
  @media ${media.desktopMax} {
    max-width: 68.438rem;
    padding: 0;
  }
`;

export default ContainerStyled;
